import {ApiShoppingCart} from '@api/shopping-carts';

export interface ShoppingCartState extends ApiShoppingCart {
    requestsCounter: number;
    requestsDone: number;
}

export const initialShoppingCartState = (): ShoppingCartState | { requestsCounter: number, requestsDone: number} | undefined  => {
  return {
      requestsCounter: 0,
      requestsDone: 0
  };
};
